module.exports = __webpack_public_path__ + "static/media/projectileDiagram1.445f7c13.svg";